import React from 'react';
import { Circle, Path, Svg } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

interface ConsentEmailIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
  circleColor?: keyof AppColors;
}

export const ConsentEmailIcon: React.FC<ConsentEmailIconProps> = ({
  size = 80,
  color = 'iconPrimary',
  circleColor = 'borderSubtle',
}) => {
  const { theme: colors } = useUnistyles();
  return (
    <Svg width={size} height={size} viewBox="0 0 80 80" fill="none">
      <Circle
        cx={40}
        cy={40}
        r={39}
        stroke={colors[circleColor]}
        strokeWidth={2}
      />
      <Path
        d="M50.23 36.275c2.064 0 3.77-1.646 3.77-3.638C54 30.646 52.294 29 50.23 29s-3.76 1.646-3.76 3.637c0 1.992 1.696 3.638 3.76 3.638ZM31.412 49h17.492c1.956 0 3.086-1.09 3.086-3.25v-8.343a5.118 5.118 0 0 1-1.662.293v8.208l-6.204-5.923 3.26-3.092a4.96 4.96 0 0 1-1.185-1.027l-4.868 4.633c-.467.45-.89.65-1.314.65-.435 0-.848-.2-1.315-.65l-8.203-7.81a2.3 2.3 0 0 1 .847-.146h13.636c0-.566.109-1.111.304-1.604h-14.2C29.13 30.94 28 32.02 28 34.18V45.75C28 47.92 29.14 49 31.412 49Zm-1.75-3.25V34.064l6.248 5.922-6.237 5.954c-.01-.063-.01-.126-.01-.188Zm10.355-2.987c.76 0 1.5-.304 2.26-1.027l.706-.671 6.475 6.184c-.228.105-.5.147-.814.147H31.346c-.304 0-.565-.042-.793-.136l6.498-6.195.706.67c.76.724 1.488 1.028 2.26 1.028Z"
        fill={colors[color]}
      />
    </Svg>
  );
};
